import Vue from 'vue';
import Router from 'vue-router';
import Form from './components/Form';
import ThankYou from './views/ThankYou';
import ErrorView from './views/Error';
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/thank-you',
      name: 'thank-you',
      props: true,
      component: ThankYou
    },
    {
      path: '/:id',
      name: 'form',
      component: Form
    },
    {
      path: '/error',
      name: 'error',
      props: true,
      component: ErrorView
    },
  ]
})
